module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "t1"
  }, [_vm._v("Readers love")])]), _vm._v(" "), _c('p', {
    staticClass: "p0"
  }, [_c('span', {
    staticClass: "t2"
  }, [_vm._v("L.J. L")]), _c('span', {
    staticClass: "t3"
  }, [_vm._v("A")]), _c('span', {
    staticClass: "t2"
  }, [_vm._v("B")]), _c('span', {
    staticClass: "t3"
  }, [_vm._v("ARTHE")])]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_c('img', {
    attrs: {
      "alt": "img1.jpg",
      "src": "Images/img1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "p3"
  }, [_c('span', {
    staticClass: "t5"
  }, [_vm._v("City of Jade")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_vm._v("“I enjoyed it. I liked our main characters and… the heroes and side characters are interesting…”")]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_vm._v("—All About Romance")]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "t5"
  }, [_vm._v("The Crystal Lake")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_vm._v("“L.J. LaBarthe is a master story teller and this series is a must read! Once you do, you will want to revisit it often, I know I do!”")]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_vm._v("—Top 2 Bottom Reviews")]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "t5"
  }, [_vm._v("A Shot in the Dark")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_vm._v("“Intense, fast paced and well written. Great read.”")]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_vm._v("—MM Good Book Reviews")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-47993f62","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/002.vue
// module id = 57
// module chunks = 0